import { useIntl } from 'react-intl';

import { toHexString } from '../../components/HexSerial';

const GatewayName = ({ name, serialNumber, formatted }) => {
  const { formatMessage } = useIntl();

  if (name && serialNumber) {
    return formatMessage(
      { id: 'data-store.list.named-gateway' },
      {
        gatewayName: name,
        gatewaySerialNumber: toHexString(serialNumber),
      }
    );
  }

  if (name) {
    return name;
  }

  if (serialNumber) {
    return formatted
      ? formatMessage(
          { id: 'data-store.list.unnamed-gateway-with-serial-formatted' },
          {
            gatewaySerialNumber: toHexString(serialNumber),
            // eslint-disable-next-line react/no-unstable-nested-components
            i: (...chunks) => <i>{chunks}</i>,
          }
        )
      : formatMessage(
          { id: 'data-store.list.unnamed-gateway-with-serial' },
          {
            gatewaySerialNumber: toHexString(serialNumber),
          }
        );
  }

  return formatted
    ? formatMessage(
        { id: 'data-store.list.unnamed-gateway-formatted' },
        {
          // eslint-disable-next-line react/no-unstable-nested-components
          i: (...chunks) => <i>{chunks}</i>,
        }
      )
    : formatMessage({ id: 'data-store.list.unnamed-gateway' });
};

export default GatewayName;
